export default "__VITE_ASSET__DyyP2PcA__";